export interface GpsCountry {
  code: string;
  name: string;
  link: string;
}

export enum GPS_REGION_CODE {
  NORTH_AMERICA = "NA",
  LATIN_AMERICA = "LA",
  AFRICA = "AF",
  MIDDLE_EAST = "ME",
  EUROPE = "EU",
  ASIA_PACIFIC = "AP",
}

export interface GpsRegion {
  code: GPS_REGION_CODE;
  name: string;
  image?: string;
  countries: GpsCountry[];
}
